import { render, staticRenderFns } from "./RoleEditorPullout.vue?vue&type=template&id=18d71e6f&scoped=true&"
import script from "./RoleEditorPullout.vue?vue&type=script&lang=js&"
export * from "./RoleEditorPullout.vue?vue&type=script&lang=js&"
import style0 from "./RoleEditorPullout.vue?vue&type=style&index=0&id=18d71e6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d71e6f",
  null
  
)

export default component.exports